import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const FieldIssueWorkflowRoute: RouteType = {
  name: "Field Issue Workflow",
  path: "/workflows/field-issue",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Field Issue Creation",
      component: () => import("./FieldIssueWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./FieldIssueWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const fieldActivityIssuesStore = rootStore.fieldActivityIssuesStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const teamStore = rootStore.teamStore as ServiceStore;

      await Promise.all([
        fieldActivityIssuesStore?.find(),
        jobStore?.find(),
        panelStore?.find(),
        userStore?.find(),
        teamStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for field issue:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).fieldIssueWorkflowStore;
    store?.reset();
  },
};

export default FieldIssueWorkflowRoute;